<template>
  <div>
    <v-dialog ref="dialog_datepicker" no-click-animation v-model="datepicker" :return-value.sync="selectedDate" persistent lazy full-width width="290px" transition="slide-y-transition">
          <v-date-picker v-model="selectedDate" :max="maxDate" scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="$parent.fn_closeDialog">Cancel</v-btn>
            <v-btn flat color="primary" @click="fn_saveDate(selectedDate)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
  </div>
</template>

<script>
let currentDateObj = new Date();

export default{
  props:['selected', 'maxDate', 'updateDate'],
  data(){
    return{
      datepicker: false,
      selectedDate:new Date()
    }
  },
  methods:{
    openDialogWeb: function () {
      // let dateObj = new Date(this.selected);
      let dateObj = null;
      // doing this hack as in some old devices (tablet which harish have) "selected" props not working
      if(this.selected){
        dateObj = new Date(this.selected);
      }
      else{
        dateObj = new Date(this.$parent.Form.transactionData.transactionDate);
      }
      this.selectedDate = dateObj.getFullYear()+'-'+("0" + (dateObj.getMonth()+1)).slice(-2)+'-'+("0" + dateObj.getDate()).slice(-2);
      this.datepicker = true;
    },
    closeDialogWeb: function () {
      this.datepicker = false;
    },
    fn_saveDate: function (value) {
      let dateObj = new Date(value);
      this.$refs.dialog_datepicker.save(value);
      this.updateDate(dateObj);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/party_balance/dialogs/dialog_datepicker.vue